import { Route, Routes } from "react-router-dom";
import CostSuppliersPage from "./CostSuppliersPage";
import SupplierPage from "./supplier";

const SuppliersRoutes = () => (
  <Routes>
    <Route>
      <Route index element={<CostSuppliersPage />} />
      <Route path=":id" element={<SupplierPage />} />
    </Route>
  </Routes>
);

export default SuppliersRoutes;
